import { getObjectKeys } from '@pkg/types';

import { type FeatureFlags } from '@app/store/types/features';

/**
 * Sets all the values of an object to a given value.
 */
export const toggleAllFeatueFlags = (featureFlags: FeatureFlags, value: boolean): FeatureFlags => {
    getObjectKeys(featureFlags).map((key) => {
        featureFlags[key] = value;
    });

    return featureFlags;
};
